export function addHoursToTime(value, hours) {
  if (!/^\d{2}:\d{2}$/.test(value || "")) return "";
  const [hour, minute] = value.split(":").map(Number);
  if (hour < 0 || hour > 23 || minute < 0 || minute > 59) return "";

  const minutesPerDay = 24 * 60;
  const shiftedMinutes = ((hour * 60 + minute + hours * 60) % minutesPerDay + minutesPerDay) % minutesPerDay;
  const shiftedHour = Math.floor(shiftedMinutes / 60);
  const shiftedMinute = shiftedMinutes % 60;
  return `${String(shiftedHour).padStart(2, "0")}:${String(shiftedMinute).padStart(2, "0")}`;
}
